import { useEffect } from "react";
import { useAuthStore } from "@/stores/auth.store";
import { connectWs, disconnectWs } from "./ws-client";

// Ciclo de vida do canal de tempo real no FE.
// Sem este hook, connectWs() nunca é chamado: o socket nunca existe, o
// RealtimeBadge fica preso em "Offline" e useRealtimeInvalidate é inerte.
// Dirigido pela PRESENÇA de sessão (não pelo valor do token): autenticado →
// connectWs(); logout/expiração/unmount → disconnectWs(). A rotação de token NÃO
// reconecta — o socket.io reusa a conexão e o handshake lê o token mais recente via
// `auth` função em ws-client, então não há churn nem flap do badge a cada refresh.
export function useRealtimeConnection(): void {
  // Presença de SESSÃO (usuário), não valor do token: após F5 a sessão pode existir com o token
  // ainda sendo reposto (cookie httpOnly `opus_access`); usar accessToken aqui mantinha o socket
  // offline no refresh. O handshake lê o token mais recente via a função `auth` do ws-client.
  const isAuthenticated = useAuthStore((s) => s.user !== null);

  useEffect(() => {
    if (isAuthenticated) {
      connectWs();
    } else {
      disconnectWs();
    }
    return () => {
      disconnectWs();
    };
  }, [isAuthenticated]);
}
